import { render, staticRenderFns } from "./start-page-loader.vue?vue&type=template&id=49bc74d8"
import script from "./start-page-loader.vue?vue&type=script&lang=js"
export * from "./start-page-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports